import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { detectRegion } from '../utils/geoDetect';
import Home from './Home';

export default function GeoRedirect() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    detectRegion().then(region => {
      if (region !== 'global') {
        navigate(`/${region}`, { replace: true });
      }
    });
  }, [navigate]);

  // Render global homepage immediately: regional users see a very brief flash
  // before the redirect fires (typically < 300 ms on fast connections)
  return <Home />;
}
